import { createSlice, createEntityAdapter } from '@reduxjs/toolkit';

const selectMenuItemId = (item) => item._id || item.id;
const menuItemsAdapter = createEntityAdapter({ selectId: selectMenuItemId });

const initialState = menuItemsAdapter.getInitialState({
	categories: [],
});

const menuSlice = createSlice({
	name: 'menu',
	initialState,
	reducers: {
		setMenuItems: (state, action) => {
			menuItemsAdapter.setAll(state, action.payload || []);
		},
		upsertMenuItems: (state, action) => {
			menuItemsAdapter.upsertMany(state, action.payload || []);
		},
		setCategories: (state, action) => {
			state.categories = Array.isArray(action.payload) ? action.payload : [];
		},
		clearMenu: (state) => {
			menuItemsAdapter.removeAll(state);
			state.categories = [];
		},
	},
});

export const { setMenuItems, upsertMenuItems, setCategories, clearMenu } = menuSlice.actions;
export default menuSlice.reducer;

const selectMenuState = (state) => state.menu;
export const { selectAll: selectAllMenuItems, selectById: selectMenuItemById, selectIds: selectMenuItemIds } =
	menuItemsAdapter.getSelectors(selectMenuState);


